import React from 'react';
import { WiTime4 } from "react-icons/wi";
import { GiReceiveMoney } from "react-icons/gi";
import { RiTeamLine } from "react-icons/ri";
import { FaRegCheckCircle } from "react-icons/fa";
import { RiCustomerService2Fill } from "react-icons/ri";
import { AiOutlineStock } from "react-icons/ai";

const services = [
  {
    icon: <WiTime4 />,
    title: "Timely Delivery",
    desc: "We ensure smooth project execution through careful planning and proactive management. This helps avoid delays and control unexpected costs.",
    aosstyle: "fade-right"
  },
  {
    icon: <GiReceiveMoney />,
    title: "Budget Control",
    desc: "We avoid delays and unexpected costs, ensuring a smooth process from start to finish.",
    aosstyle: "fade-down"
  },
  {
    icon: <RiTeamLine />,
    title: "Experienced Team",
    desc: "Our team includes designers, architects, engineers, and project managers with deep experience.",
    aosstyle: "fade-right"
  },
  {
    icon: <FaRegCheckCircle />,
    title: "High Quality Materials",
    desc: "Quality is at the heart of our work — from premium materials to flawless finishes.",
    aosstyle: "fade-right"
  },
  {
    icon: <RiCustomerService2Fill />,
    title: "Transparent Communication",
    desc: "We maintain clear and open communication throughout the entire process.",
    aosstyle: "fade-up"
  },
  {
    icon: <AiOutlineStock />,
    title: "Focus on Sustainability",
    desc: "We build eco-friendly, sustainable spaces that serve you and the planet.",
    aosstyle: "fade-right"
  },
];

const WhyChoose = () => {
  return (
    <div className="w-full py-16 px-4 md:px-12 lg:px-10 bg-white">
      <h1 className="text-black text-3xl md:text-4xl font-extrabold text-center mb-12">
        Why Choose Us
      </h1>

      <div className="grid gap-8 md:gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {services.map((item, i) => (
          <div
            key={i}
            className="group bg-black text-white p-6 rounded-md h-[319px] overflow-hidden transition-all duration-500 hover:shadow-xl"
            data-aos={item.aosstyle} >
            <div className="text-6xl transform transition-transform duration-500 group-hover:-translate-y-3">
              {item.icon}
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mt-4 mb-2 transform transition-transform duration-500 group-hover:translate-x-2" >
              {item.title}
            </h2>
            <p className="text-base md:text-lg leading-relaxed transform transition-transform duration-500 group-hover:translate-x-2">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChoose;
